<template>
  <div class="busi-oppty-order-list">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <div class="panel-box">
      <eb-search
        ref="busiSearchDepartName"
        class="search-long"
        :placeholder="placeholder"
        :animate="false"
        @search-click="searchDepartList"
        style="justify-content: flex-start;"
      ></eb-search>
      <br>
      <div class="search-result">
        <template v-if="searchDepartName !== ''">
          <template v-if="busiOpptyList.length > 0">
            <div
              class="search-result-item"
              v-for="(item, $index) in busiOpptyList"
              :key="$index"
            >
              <div class="search-result-title">
                {{item.departName}}
              </div>
              <div class="search-result-body">
                <el-checkbox-group v-model="checkedBusiOpptyList">
                  <el-checkbox
                    class="eb-checkbox"
                    :label="item"
                  >{{item.busiOpptyDesc}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="search-result-item">
              <div class="search-result-item_none webkit-font-somthing">
                没有搜索到采购方机构名称。可能原因有: <br /><br /> 1、没有输入机构全称；
                <br /> 2、此机构不存在；
                <br /> 3、此机构设置自身为“禁止被关注”。
              </div>
            </div>
          </template>
        </template>
      </div>
      <br>
      <el-button
        v-if="searchDepartName"
        class="eb-button-group-btn eb-button-orange eb-button-big"
        :disabled="checkedBusiOpptyList == 0"
        @click="showWeixinPayDialog()"
      >支付订购</el-button>
      <!--<el-button
        v-if="!searchDepartName"
        class="eb-button-group-btn eb-button-orange eb-button-big"
        @click="searchClick()"
      >搜索</el-button> -->
    </div>
    <WeixinQRCodePay
      ref="weixinQRCodePay"
      @paymentComplete="wxPaymentComplete"
      :isVisible.sync="weixinPay.isVisible"
    >
      <!-- <template slot="info">
        <div>{{checkedBusiOpptyList.length > 0 ? checkedBusiOpptyList[0].busiOpptyDesc : ''}}</div>
        <div>订单号:{{sysOrderNumber}}</div>
      </template> -->
      <!-- <template slot="info">
        <div class="weixinQRCodePayTitle">
          <div class="weixinQRCodePayTitle_left">{{checkedBusiOpptyList.length > 0 ? busiOpptyTemplateOne.desc : ''}}。订单号：{{sysOrderNumber}}</div>
          <div class="weixinQRCodePayTitle_right">应付金额
            <span class="weixinQRCodePayTitle_right_price">{{busiOpptyTemplateOne.price}}</span>元</div>
        </div>
      </template> -->
    </WeixinQRCodePay>
  </div>
</template>

<script>
import moment from 'moment';
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import EbSearch from '@/components/common/eb-search';
import EventBus from '@/plugins/event-bus';
import QRCode from 'qrcode';
import { getDepartmentByName, checkIsCanReceiveBusiPush } from '@/services/busi/business-push-service'; // savePaymentInfo
import { getUserById } from '@/services/user/user-service';

export default {
  components: {
    ebHeader,
    ebBreakCrumb,
    EbSearch,
    WeixinQRCodePay: () => import('@/components/weixin/pay/WeixinQRCodePay')
  },
  data() {
    return {
      placeholder: '请输入需要关注的采购方完整名称，简称无法搜索',
      searchDepartName: '',
      depart: null,
      busiOpptyTemplate: '订购此机构的易比得信息推送，有效期12个月（{DateDuration}），服务费50元。',
      busiOpptyTemplateOne: {
        desc: '订购此机构的易比得信息推送，有效期12个月（{DateDuration}）',
        price: '50.00'
      },
      // 商机列表
      busiOpptyList: [],
      // 选中的商机
      checkedBusiOpptyList: [],
      sysOrderNumber: '', // 系统订单号
      // payment: {
      //   sysOrderNumber: '',
      //   orderType: '',
      //   paymentUserId: '',
      //   transationNumber: '',
      //   transationType: 'W2',
      //   transationAmount: null,
      //   transationState: '',
      //   transationError: ''
      // },
      weixinPay: {
        isVisible: false
      },
      user: this.$store.state.user.userInfo
    };
  },
  created() {
    this.$root.layout.isLoading = false;
  },
  computed: {},
  mounted() {},
  methods: {
    // 查询要订购商机的机构
    async searchDepartList(departName) {
      this.searchDepartName = departName;
      if (!departName) return;

      this.busiOpptyList = [];

      try {
        let { data } = await getDepartmentByName(departName);
        if (data.returnCode === '01') {
          this.depart = null;
          this.checkedBusiOpptyList = [];

          if (data.depart == null) {
            this.busiOpptyList = [];
            return;
          }

          this.depart = data.depart;
          let startDate = moment().format('YYYY/MM/DD');
          let endDate = moment()
            .add(1, 'y')
            .subtract(1, 'd')
            .format('YYYY/MM/DD');
          let dateDuration = startDate + '~' + endDate;
          // 清空数组
          this.busiOpptyList.splice(0, this.busiOpptyList.length);

          this.busiOpptyList.push({
            orderType: 'SJTS1804',
            departId: this.depart.departId,
            content: '易比得合规采购云信息推送',
            amount: 1,
            departName: this.depart.departName,
            startDate: startDate,
            endDate: endDate,
            busiOpptyDesc: this.busiOpptyTemplate.replace('{DateDuration}', dateDuration)
          });
          this.busiOpptyTemplateOne.desc = this.busiOpptyTemplateOne.desc.replace('{DateDuration}', dateDuration);
        } else {
          throw new Error('查询机构列表失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 显示微信支付对话框
    async showWeixinPayDialog() {
      // 显示支付窗口
      if (this.checkedBusiOpptyList.length > 0) {
        let busiOppty = this.checkedBusiOpptyList[0];
        let checkRes = await this.checkIsCanReceiveBusiPush(busiOppty.departId);
        if (checkRes) {
          return;
        }
        // 初始化订单号
        // await this.initOrderNo();
        // 显示微信支付窗口
        this.weixinPay.isVisible = true;
        // 初始化微信支付二维码
        EventBus.$emit('initWeixinPayQRCode', {
          productId: busiOppty.orderType,
          outTradeNo: null,
          body: busiOppty.content,
          price: this.busiOpptyTemplateOne.price,
          desc: this.busiOpptyTemplateOne.desc,
          orderParams: {
            orderType: busiOppty.orderType,
            buyerOrgId: busiOppty.departId
          }
        });
      } else {
        this.$message.error('请选择要订购的商机');
      }
    },
    // 保存支付信息
    async wxPaymentComplete(weixinPayInfo) {
      if (weixinPayInfo.status === 'SUCCESS') {
        this.sysOrderNumber = weixinPayInfo.outTradeNo;
        this.goOrderSuccessPage();
      } else {
        this.$message.error('微信支付失败');
      }
    },
    // 跳转到订单支付成功页
    async goOrderSuccessPage() {
      let { data: userData } = await getUserById(this.user.userid);
      // console.log(userData, 'userData');
      if (userData.returnCode === '01') {
        let busiOppty = this.checkedBusiOpptyList[0];
        let busiOpptyOrderSuccess = {
          orgName: busiOppty.departName
        };
        // 订购周期
        let dateDuration = busiOppty.startDate + '~' + busiOppty.endDate;
        if (userData.user.openidPublic) {
          let nickname = userData.user.nickname;
          // 已关注
          busiOpptyOrderSuccess.isSubscribe = true;
          busiOpptyOrderSuccess.msg =
            '您已成功订购信息推送服务12个月，有效期 ' +
            dateDuration +
            '。<br>相关商机将推送至您的微信号“' +
            nickname +
            '”。';
        } else {
          // 未关注
          busiOpptyOrderSuccess.isSubscribe = false;
          busiOpptyOrderSuccess.msg = '您已成功订购信息推送服务12个月，有效期 ' + dateDuration;
          busiOpptyOrderSuccess.subscribeMsg =
            '您还没有关注易比得微信公众号，因此无法及时收到推送信息。请您参考下图：退出登录，使用微信扫码功能绑定微信号后，即可收到新的商机推送。';
        }
        busiOpptyOrderSuccess.sysOrderNumber = this.sysOrderNumber;
        sessionStorage.setItem('busiOpptyOrderSuccess', JSON.stringify(busiOpptyOrderSuccess));
        this.$router.push({ path: '/busi/opptyorder/success' });
      }
    },
    async checkIsCanReceiveBusiPush(departId) {
      try {
        let { data } = await checkIsCanReceiveBusiPush(this.user.userid, departId);
        if (data.returnCode === '01') {
          if (data.result === true) {
            this.$message.info('您已订购了此机构的信息推送，无需重复订购。');
            return true;
          } else {
            return false;
          }
        } else {
          throw new Error('查询用户商机订购信息失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
        return true;
      }
    },
    searchClick: function() {
      this.$refs.busiSearchDepartName.searchClick();
    },
    test() {
      this.sysOrderNumber = '180508127647';

      this.weixinOrderInfo.codeURL = 'weixin://wxpay/bizpayurl?pr=cubA4m4';
      this.weixinOrderInfo.rorCode = 'ERR001';
      this.weixinOrderInfo.rorMsg = '操作成功';
      this.weixinOrderInfo.epayId = 'wx08145741128226ef52a825600468626654';
      this.weixinOrderInfo.turnCode = '01';
      this.weixinOrderInfo.ansationType = 'W1';

      let opptyOrderQRCode = document.querySelector('#opptyOrderQRCode');
      let _this = this;
      QRCode.toCanvas(opptyOrderQRCode, this.weixinOrderInfo.codeURL, function(error) {
        if (error) console.error(error);
        _this.getOrderPayStatus();
      });
    }
  }
};
</script>

<style lang="less">
.busi-oppty-order-list {
  .panel-box {
    .search-result {
      .search-result-item {
        .search-result-title {
          font-size: 20px;
          font-weight: bold;
          padding: 5px;
        }
        .search-result-body {
          padding: 5px;
        }
        .search-result-item_none {
          color: #fb5b3b;
          font-family: 'SimSun';
        }
      }
    }
  }
}
</style>
